import { useState, useEffect } from 'react';

// This component allows to render a child component only on UI
// no render on SSR
const OnlyUIRender = ({ children }) => {
    const [isBrowser, setIsBrowser] = useState(false);
    useEffect(() => {
        setIsBrowser(true);
    }, []);
    return isBrowser ? children : null;
};

export { OnlyUIRender as default };
//# sourceMappingURL=index.js.map
